import env from './env'

const DEV_URL = 'https://xnapi.luobovod.com/api'
// const DEV_URL = 'http://47.95.235.115:8090/api'
// const DEV_URL = 'http://39.105.26.75:8090/api'  


const PRO_URL = 'https://xnapi.luobovod.com/api'
// const PRO_URL = 'http://47.95.235.115:8090/api'  // 旧--测试
// const PRO_URL = 'http://39.105.26.75:8090/api'   // 新--测试
export default env === 'development' ? DEV_URL : PRO_URL




//////////////////
// WEBPACK FOOTER
// ./config/url.js
// module id = FKvS
// module chunks = 131